






















import { Component, Vue, Prop} from 'vue-property-decorator';
import { api } from '../api';
import DetailField from '@/components/DetailField.vue';

@Component({
  components: { DetailField }
})
export default class SendEmailDialog extends Vue {
  @Prop(String) public baseUrl!: string;
  public dialog = false;
  public id = 0;
  public callBack: ((id: number, response: any) => void)|null = null;
  public getEmailTemplateUrl = 'getmailtemplate';
  public sendEmailUrl = 'getmailtemplate';
  public queryParams: null|object = null;
  public mailTemplate: any = {
    subject: '',
    body: ''
  };

  public async startDialog(
      id: number,
      callBackFnc: (id: number, response: any) => void,
      getEmailTemplateUrl: string = 'getmailtemplate',
      sendEmailUrl: string = 'sendmail',
      queryParams: null|object = null
      ) {
    this.id = id;
    this.callBack = callBackFnc;
    this.getEmailTemplateUrl = getEmailTemplateUrl;
    this.sendEmailUrl = sendEmailUrl;
    this.queryParams = queryParams;
    await this.getEmailTemplate();
  }
  public async getEmailTemplate() {
    const response = await api.postAction(null, this.baseUrl + (this.id ? this.id + '/' : '') + this.getEmailTemplateUrl, {}, this.queryParams);
    if (response) {
      this.mailTemplate = response.data;
    }
    this.dialog = true;
  }
  public async sendEmail() {
    if (this.queryParams) {
      for (const key of Object.keys(this.queryParams)) {
        this.mailTemplate[key] = this.queryParams[key];
      }
    }
    const response = await api.postAction(this.$store, this.baseUrl + (this.id ? this.id + '/' : '') + this.sendEmailUrl, this.mailTemplate);
    if (this.callBack) {
      this.callBack(this.id, response ? response.data : null);
    }
  }
}
